import { Link } from 'react-router-dom';
import { ROUTES } from './Navigation/routes';
import { Mail, Github, Linkedin, Calendar } from 'lucide-react';
import { BOOK_CALL_URL } from '../constants/links';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-purple-900/95 to-blue-900/95 backdrop-blur-md border-t border-white/10 text-gray-300">
      <div className="max-w-6xl mx-auto px-6 py-10">

        {/* CTA strip */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-10 pb-10 border-b border-white/10">
          <div className="text-center sm:text-left">
            <h3 className="text-xl font-bold text-white mb-1">Ready to build something?</h3>
            <p className="text-sm text-gray-400">Happy to share a couple of ideas specific to your setup.</p>
          </div>
          <div className="flex gap-3 shrink-0">
            <a
              href={BOOK_CALL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 px-5 py-2.5 rounded-lg text-sm bg-gradient-to-r from-purple-500 to-pink-500 text-white font-medium hover:from-purple-600 hover:to-pink-600 transition-colors no-underline whitespace-nowrap"
            >
              <Calendar className="w-4 h-4" /> Book a Call
            </a>
            <Link
              to={ROUTES.CONTACT}
              className="flex items-center gap-1.5 px-5 py-2.5 rounded-lg text-sm border border-white/20 text-gray-200 hover:text-white hover:border-white/40 transition-colors no-underline whitespace-nowrap"
            >
              Contact Us
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">

          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to={ROUTES.About} className="flex items-center gap-2 mb-3 group">
              <img src="/images/logo-wht.svg" alt="Stray Apps icon" className="h-8 w-8" />
              <img src="/images/Stray-wht.svg" alt="Stray Apps" className="h-8 w-auto" />
            </Link>
            <p className="text-xs text-gray-400 leading-relaxed">
              Building intelligent tools and experiences for modern teams.
            </p>
            <div className="flex gap-3 mt-4">
              <a
                href="mailto:contact@stray-apps.com"
                aria-label="Email"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Mail className="w-4 h-4" />
              </a>
              <a
                href="https://github.com/Straygames8"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Github className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-xs font-semibold text-white uppercase tracking-wider mb-3">Company</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to={ROUTES.About}    className="text-gray-400 hover:text-white transition-colors no-underline">About</Link></li>
              <li><Link to={ROUTES.Services} className="text-gray-400 hover:text-white transition-colors no-underline">Services</Link></li>
              <li><Link to={ROUTES.RESOURCES} className="text-gray-400 hover:text-white transition-colors no-underline">Resources</Link></li>
              <li><Link to={ROUTES.CONTACT} className="text-gray-400 hover:text-white transition-colors no-underline">Contact</Link></li>
            </ul>
          </div>

          {/* Apps */}
          <div>
            <h3 className="text-xs font-semibold text-white uppercase tracking-wider mb-3">Apps</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to={ROUTES.APPS_AEC}        className="text-gray-400 hover:text-white transition-colors no-underline">AEC Tools Explorer</Link></li>
              <li><Link to={ROUTES.APPS_CUSTOM}     className="text-gray-400 hover:text-white transition-colors no-underline">Custom Tools</Link></li>
              <li><Link to={`${ROUTES.CONTACT}?mode=aec`} className="text-gray-400 hover:text-white transition-colors no-underline">New Request</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-xs font-semibold text-white uppercase tracking-wider mb-3">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors no-underline">Privacy Policy</Link></li>
              <li><Link to="/terms"          className="text-gray-400 hover:text-white transition-colors no-underline">Terms of Use</Link></li>
              <li><Link to="/cookie-policy"  className="text-gray-400 hover:text-white transition-colors no-underline">Cookie Policy</Link></li>
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-gray-500">
          <span>© {year} Stray AppTech Pte. Ltd. All rights reserved.</span>
          <span>
            Registered in Singapore ·{' '}
            <a href="mailto:contact@stray-apps.com" className="hover:text-gray-300 transition-colors no-underline">
              support@stray-apps.com
            </a>
          </span>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
